module.exports = __webpack_public_path__ + "new-agent/static/fonts/MaterialIconsOutlined-Regular.4e2b3ae.otf";